// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QTV1k","colBig":"styles_colBig__3_3GI","colSmall":"styles_colSmall__1zUEr"};